import { Box, Button, Card, CardProps, Stack } from "@mui/material";
import React from "react";

interface AdminFilterPanelPrimaryAction {
  label: React.ReactNode;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

type AdminFilterPanelProps = CardProps & {
  /** Optional supporting content displayed below the page's filter controls. */
  hint?: React.ReactNode;
  /** Optional primary action displayed beside the supporting content. */
  primaryAction?: AdminFilterPanelPrimaryAction;
};

/**
 * Shared visual shell for the admin pages' top-level filters and context selectors.
 * Selection and reset behavior intentionally stays with the owning page.
 */
export const AdminFilterPanel: React.FC<AdminFilterPanelProps> = ({
  sx,
  children,
  hint,
  primaryAction,
  ...props
}) => (
  <Card sx={{ mb: 4, p: { xs: 2, sm: 3 }, ...sx }} {...props}>
    {children}
    {(hint || primaryAction) && (
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", sm: "center" }}
        sx={{ mt: 2 }}
      >
        {primaryAction && (
          <Button
            variant="contained"
            color="primary"
            startIcon={primaryAction.icon}
            onClick={primaryAction.onClick}
            disabled={primaryAction.disabled}
            sx={{ flexShrink: 0 }}
          >
            {primaryAction.label}
          </Button>
        )}
        {hint && <Box sx={{ flex: 1, minWidth: 0 }}>{hint}</Box>}
      </Stack>
    )}
  </Card>
);
